import React from "react";

const LoadingSpinner = ({ size = "default", text = "" }) => {
  // Size variants
  const sizes = {
    small: "w-8 h-8",
    default: "w-12 h-12",
    large: "w-16 h-16"
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-white/90 to-gray-50/90 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-4 sm:gap-6">
        {/* Animated Logo Spinner */}
        <div className="relative">
          {/* Outer rotating ring */}
          <div className={`${sizes[size]} rounded-full border-4 border-gray-200 border-t-blue-600 border-r-blue-500 animate-spin`}></div>

          {/* Inner pulsing dot */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-3 h-3 bg-blue-600 rounded-full animate-pulse"></div>
          </div>
        </div>

        {/* Loading text with animated dots */}
        {text && (
          <div className="flex items-center gap-1">
            <span className="text-sm sm:text-base font-medium text-gray-700">{text}</span>
            <div className="flex gap-1">
              <span className="w-1.5 h-1.5 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: "0ms" }}></span>
              <span className="w-1.5 h-1.5 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: "150ms" }}></span>
              <span className="w-1.5 h-1.5 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: "300ms" }}></span>
            </div>
          </div>
        )}

        {/* Alternative: Progress bar style loader
        <div className="w-48 sm:w-64 h-1.5 bg-gray-200 rounded-full overflow-hidden">
          <div className="h-full bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full animate-pulse" style={{ width: "60%" }}></div>
        </div>
        */}
      </div>
    </div>
  );
};

export default LoadingSpinner;